import { toast } from 'react-toastify';
import Toast from '../Toast';

const MAX_FILE_SIZE = 15 * 1024 * 1024;
const ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
const ALLOWED_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'];

const isAllowedExtension = (fileName) => {
  if (!fileName) {
    return false;
  }
  const extension = fileName.split('.').pop().toLowerCase();
  return ALLOWED_EXTENSIONS.includes(extension);
};

export const processStimulusFiles = async (files) => {
  const validFiles = [];

  for (const file of files) {
    if (file.size > MAX_FILE_SIZE) {
      toast(<Toast message={`${file.name} exceeds 15mb file size limit`} />);
      continue;
    }

    const fileType = file.type || '';
    const isAllowed =
      ALLOWED_TYPES.includes(fileType) || isAllowedExtension(file.name);

    if (!isAllowed) {
      toast(
        <Toast message="Only .pdf, .jpeg, .jpg or .png files are accepted" />,
      );
      continue;
    }

    validFiles.push(file);
  }

  return validFiles;
};
